// 21hermosa 제품 데이터베이스
// 성분 기반 추천(Active Ingredients)을 위한 해시태그 탑재 개정본

const initialProducts = [
  // ==================== 1단계: 클렌저 (Limpiador) ====================
  {
    id: "roundlab_dokdo_cleanser",
    brand: "Round Lab",
    name: "1025 Dokdo Cleanser",
    step: 1,
    isDia: true,
    isNoche: true,
    price: "16.50",
    link: "https://21hermosa.es/products/round-lab-1025-dokdo-cleanser",
    skinTypeScore: { dry: 2, oily: 2, combination: 3, sensitive: 2 },
    concernScore: { dryness: 2, acne: 1, redness: 2, dullness: 1 },
    ageScore: { teen: 2, twenties: 3, thirties: 3, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["panthenol", "allantoin", "mineral"], // 성분 태그!
    keyIngredients: {
      es: "Agua de mar profunda de Ulleungdo, Pantenol, Alantoína",
      en: "Ulleungdo Deep Sea Water, Panthenol, Allantoin",
      ko: "울릉도 해양심층수, 판테놀, 알란토인"
    },
    description: {
      es: "Limpiador espumoso de pH equilibrado que elimina suavemente el exceso de sebo y las impurezas finas sin resecar la piel.",
      en: "A pH-balanced foaming cleanser that gently removes excess sebum and fine impurities without stripping the skin.",
      ko: "피부 수분은 남겨두고 미세 노폐물과 피지를 부드럽게 세안해주는 약산성 클렌저."
    },
    imageUrl: "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "cosrx_goodmorning_cleanser",
    brand: "COSRX",
    name: "Low pH Good Morning Gel Cleanser",
    step: 1,
    isDia: true,
    isNoche: true,
    price: "14.90",
    link: "https://21hermosa.es/products/cosrx-low-ph-good-morning-gel-cleanser",
    skinTypeScore: { dry: 1, oily: 3, combination: 3, sensitive: 1 },
    concernScore: { dryness: 1, acne: 3, redness: 1, dullness: 1 },
    ageScore: { teen: 3, twenties: 2, thirties: 2, forties: 1 },
    pregnancySafe: true,
    fragranceFree: false, // 티트리 천연 에센셜 오일 함유
    sunscreenType: "none",
    ingredientsTags: ["teatree", "bha"], // 티트리, BHA 성분 매칭!
    keyIngredients: {
      es: "Aceite de hoja de árbol de té, BHA (Salicilato de betaína) 0.5%",
      en: "Tea Tree Leaf Oil, BHA (Betaine Salicylate) 0.5%",
      ko: "티트리잎오일, BHA (베타인살리실레이트) 0.5%"
    },
    description: {
      es: "Gel limpiador purificante de pH bajo que elimina suavemente el sebo acumulado y combate las imperfecciones gracias al aceite de árbol de té.",
      en: "A purifying low-pH gel cleanser that gently removes buildup and targets acne with natural tea tree oil.",
      ko: "티트리 오일과 BHA 성분이 아침 피부의 노폐물과 유분을 가볍게 제거해주는 약산성 젤 클렌저."
    },
    imageUrl: "https://images.unsplash.com/photo-1608248597481-496100c80836?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "skin1004_centella_foam",
    brand: "Skin1004",
    name: "Madagascar Centella Ampoule Foam",
    step: 1,
    isDia: true,
    isNoche: true,
    price: "15.90",
    link: "https://21hermosa.es/products/skin1004-madagascar-centella-ampoule-foam",
    skinTypeScore: { dry: 2, oily: 1, combination: 2, sensitive: 3 },
    concernScore: { dryness: 2, acne: 1, redness: 3, dullness: 1 },
    ageScore: { teen: 2, twenties: 3, thirties: 3, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["centella"], // 병풀(센텔라)
    keyIngredients: {
      es: "33% Extracto de Centella Asiática de Madagascar, Bicarbonato de Sodio",
      en: "33% Madagascar Centella Asiatica Extract, Sodium Bicarbonate",
      ko: "마다가스카르산 병풀 추출물 33%, 자연유래 베이킹소다"
    },
    description: {
      es: "Espuma limpiadora hipoalergénica enriquecida con centella asiática que calma la piel sensible mientras limpia los poros a fondo.",
      en: "Hypoallergenic cleansing foam enriched with centella asiatica to soothe sensitive skin while thoroughly clearing pores.",
      ko: "자극받은 민감성 피부를 즉각적으로 진정시키며 조밀한 거품으로 말끔하게 노폐물을 지워주는 저자극 폼."
    },
    imageUrl: "https://images.unsplash.com/photo-1617897903246-719242758050?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "anua_cleansing_oil",
    brand: "Anua",
    name: "Heartleaf Pore Control Cleansing Oil",
    step: 1,
    cleanserType: "oil", // 저녁 1차 오일 세안
    isDia: false, // 저녁 세안 전용
    isNoche: true,
    price: "23.90",
    link: "https://21hermosa.es/products/anua-heartleaf-pore-control-cleansing-oil",
    skinTypeScore: { dry: 2, oily: 3, combination: 3, sensitive: 2 },
    concernScore: { dryness: 1, acne: 3, redness: 2, dullness: 1 },
    ageScore: { teen: 3, twenties: 3, thirties: 2, forties: 1 },
    pregnancySafe: true,
    fragranceFree: false,
    sunscreenType: "none",
    ingredientsTags: ["heartleaf", "jojoba"], // 어성초
    keyIngredients: {
      es: "Extracto de Houttuynia Cordata (Heartleaf), Aceite de Semilla de Jojoba",
      en: "Houttuynia Cordata Extract, Jojoba Seed Oil",
      ko: "어성초 추출물, 호호바씨 오일"
    },
    description: {
      es: "Limpiador en aceite ligero no comedogénico que elimina eficazmente el maquillaje resistente, el sebo y los puntos negros sin obstruir los poros.",
      en: "Non-comedogenic lightweight oil cleanser that melts away waterproof makeup, excess sebum, and blackheads without clogging pores.",
      ko: "여드름성 피부도 안심하고 사용하는 가벼운 제형의 클렌징 오일로 블랙헤드와 메이크업을 말끔히 세정."
    },
    imageUrl: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "joseon_ginseng_oil",
    brand: "Beauty of Joseon",
    name: "Ginseng Cleansing Oil",
    step: 1,
    cleanserType: "oil", // 저녁 1차 오일 세안
    isDia: false,
    isNoche: true,
    price: "21.00",
    link: "https://21hermosa.es/products/beauty-of-joseon-ginseng-cleansing-oil",
    skinTypeScore: { dry: 3, oily: 1, combination: 2, sensitive: 2 },
    concernScore: { dryness: 3, acne: 1, redness: 1, dullness: 2 },
    ageScore: { teen: 1, twenties: 2, thirties: 3, forties: 3 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["ginseng", "soybean"], // 인삼
    keyIngredients: {
      es: "50% Aceite de Semilla de Glycine Soja, 0.1% Aceite de Semilla de Ginseng",
      en: "50% Glycine Soja Oil, 0.1% Ginseng Seed Oil",
      ko: "돌콩오일 50%, 인삼씨오일 0.1%"
    },
    description: {
      es: "Aceite limpiador enriquecido con ginseng que nutre profundamente la piel madura y seca mientras retira delicadamente la suciedad diaria.",
      en: "A nourishing cleansing oil infused with ginseng to deeply condition dry and mature skin while gently lifting impurities.",
      ko: "인삼의 깊은 영양감을 담은 클렌징 오일로, 세안 단계부터 건조한 노화 피부에 보습을 충전."
    },
    imageUrl: "https://images.unsplash.com/photo-1601049541289-9b1b7bbbfe19?auto=format&fit=crop&q=80&w=200"
  },

  // ==================== 2단계: 토너 (Tónico) ====================
  {
    id: "anua_heartleaf_toner",
    brand: "Anua",
    name: "Heartleaf 77% Soothing Toner",
    step: 2,
    isDia: true,
    isNoche: true,
    price: "22.50",
    link: "https://21hermosa.es/products/anua-heartleaf-77-soothing-toner",
    skinTypeScore: { dry: 2, oily: 3, combination: 3, sensitive: 3 },
    concernScore: { dryness: 2, acne: 3, redness: 3, dullness: 1 },
    ageScore: { teen: 3, twenties: 3, thirties: 2, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["heartleaf", "centella"], // 어성초, 병풀(센텔라)
    keyIngredients: {
      es: "77% Extracto de Houttuynia Cordata (Heartleaf), Centella Asiática",
      en: "77% Heartleaf Extract, Centella Asiatica",
      ko: "어성초 추출물 77%, 병풀 추출물"
    },
    description: {
      es: "El tónico número 1 en Corea. Formulado con un 77% de extracto de 어성초 para calmar al instante las pieles sensibles y con rojeces.",
      en: "Korea's absolute favorite toner. Packed with 77% Heartleaf extract to soothe sensitive, red, and acne-prone skin instantly.",
      ko: "자극받은 민감 피부를 잠재우는 어성초 77% 토너. 붉은기 개선 및 피지 진정에 탁월."
    },
    imageUrl: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "roundlab_dokdo_toner",
    brand: "Round Lab",
    name: "1025 Dokdo Toner",
    step: 2,
    isDia: true,
    isNoche: true,
    price: "18.00",
    link: "https://21hermosa.es/products/round-lab-1025-dokdo-toner",
    skinTypeScore: { dry: 3, oily: 2, combination: 3, sensitive: 2 },
    concernScore: { dryness: 3, acne: 1, redness: 2, dullness: 2 },
    ageScore: { teen: 2, twenties: 3, thirties: 3, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["panthenol", "allantoin", "hyaluronic"], // 판테놀, 알란토인, 히알루론산
    keyIngredients: {
      es: "Agua de Mar Profunda, HATCHKET-7 (Exfoliante suave), Pantenol",
      en: "Deep Sea Water, HATCHKET-7 (Mild exfoliator), Panthenol",
      ko: "해양심층수, 마일드 각질케어 HATCHKET-7, 판테놀"
    },
    description: {
      es: "Tónico hidratante que exfolia suavemente las células muertas de la piel con enzimas naturales, mejorando la textura sin causar irritación.",
      en: "An intensively hydrating toner that mildly sweeps away dead skin cells using natural enzymes, smoothing texture without irritation.",
      ko: "자극 없이 묵은 각질을 정돈해주고 수분을 깊숙이 채워 화장이 잘 먹게 돕는 수분 토너."
    },
    imageUrl: "https://images.unsplash.com/photo-1608248597481-496100c80836?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "joseon_ginseng_essence",
    brand: "Beauty of Joseon",
    name: "Ginseng Essence Water",
    step: 2,
    isDia: true,
    isNoche: true,
    price: "19.90",
    link: "https://21hermosa.es/products/beauty-of-joseon-ginseng-essence-water",
    skinTypeScore: { dry: 3, oily: 1, combination: 2, sensitive: 2 },
    concernScore: { dryness: 3, acne: 1, redness: 2, dullness: 3 },
    ageScore: { teen: 1, twenties: 2, thirties: 3, forties: 3 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["ginseng", "niacinamide"], // 인삼, 나이아신아마이드
    keyIngredients: {
      es: "80% Agua de Raíz de Ginseng, 2% Niacinamida, Pantenol",
      en: "80% Ginseng Root Water, 2% Niacinamide, Panthenol",
      ko: "인삼수 80%, 나이아신아마이드 2%, 판테놀"
    },
    description: {
      es: "Tónico-esencia concentrado de ginseng que infunde una rica nutrición y propiedades antioxidantes en las pieles secas y maduras.",
      en: "A deeply nourishing ginseng-water essence that revitalizes dry and aging skin with abundant nutrients and antioxidants.",
      ko: "풍부한 인삼 에너지가 기미와 칙칙함을 개선하고 건조한 피부에 깊은 영양감을 공급하는 영양 에센스 토너."
    },
    imageUrl: "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?auto=format&fit=crop&q=80&w=200"
  },

  // ==================== 3단계: 세럼/에센스 (Esencia/Sérum) ====================
  {
    id: "torriden_divein_serum",
    brand: "Torriden",
    name: "Dive-In Soothing Hyaluronic Acid Serum",
    step: 3,
    isDia: true,
    isNoche: true,
    price: "19.50",
    link: "https://21hermosa.es/products/torriden-dive-in-low-molecular-hyaluronic-acid-serum",
    skinTypeScore: { dry: 3, oily: 2, combination: 3, sensitive: 2 },
    concernScore: { dryness: 3, acne: 1, redness: 2, dullness: 1 },
    ageScore: { teen: 2, twenties: 3, thirties: 3, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["hyaluronic", "panthenol", "allantoin"], // 히알루론산, 판테놀, 알란토인
    keyIngredients: {
      es: "Ácido Hialurónico de Bajo Peso Molecular de 5 tipos, D-Pantenol, Alantoína",
      en: "5 types of Low Molecular Hyaluronic Acid, D-Panthenol, Allantoin",
      ko: "5중 복합 저분자 히알루론산, D-판테놀, 알란토인"
    },
    description: {
      es: "Sérum súper hidratante de absorción rápida que soluciona la deshidratación interna (속건조) rellenando la piel de agua desde dentro.",
      en: "An ultra-hydrating, fast-absorbing serum designed to tackle inner-dryness by replenishing moisture layers within the skin.",
      ko: "피부 속건조를 즉각적으로 꽉 해결해주는 5중 복합 저분자 히알루론산 수분 세럼."
    },
    imageUrl: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "skin1004_centella_ampoule",
    brand: "Skin1004",
    name: "Madagascar Centella Ampoule",
    step: 3,
    isDia: true,
    isNoche: true,
    price: "18.90",
    link: "https://21hermosa.es/products/skin1004-madagascar-centella-ampoule",
    skinTypeScore: { dry: 2, oily: 2, combination: 2, sensitive: 3 },
    concernScore: { dryness: 2, acne: 2, redness: 3, dullness: 1 },
    ageScore: { teen: 3, twenties: 3, thirties: 3, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["centella"], // 병풀 (센텔라)
    keyIngredients: {
      es: "100% Extracto de Centella Asiática purificada de Madagascar",
      en: "100% Madagascar Centella Asiatica Extract",
      ko: "마다가스카르산 병풀 추출물 100% 단일 성분"
    },
    description: {
      es: "Ampolla calmante formulada con un único ingrediente activo para restaurar la barrera dañada y aliviar pieles ultra-sensibles o con rojeces.",
      en: "A signature soothing ampoule containing 100% pure centella to instantly calm sensitive, damaged, and red-prone skin.",
      ko: "100% 순수 병풀 추출물 성분으로 붉어지고 손상된 피부 장벽을 편안하게 진정시키는 시그니처 앰플."
    },
    imageUrl: "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "joseon_glow_serum",
    brand: "Beauty of Joseon",
    name: "Glow Serum : Propolis + Niacinamide",
    step: 3,
    isDia: true,
    isNoche: true,
    price: "18.50",
    link: "https://21hermosa.es/products/beauty-of-joseon-glow-serum-propolis-niacinamide",
    skinTypeScore: { dry: 3, oily: 2, combination: 3, sensitive: 2 },
    concernScore: { dryness: 2, acne: 3, redness: 2, dullness: 3 },
    ageScore: { teen: 2, twenties: 3, thirties: 3, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["propolis", "niacinamide", "bha"], // 프로폴리스, 나이아신아마이드, BHA
    keyIngredients: {
      es: "60% Extracto de Propóleo, 2% Niacinamida, 0.5% BHA",
      en: "60% Propolis Extract, 2% Niacinamide, 0.5% BHA",
      ko: "프로폴리스 추출물 60%, 나이아신아마이드 2%, BHA 0.5%"
    },
    description: {
      es: "Consigue una piel radiante y sin imperfecciones. Regula el sebo, minimiza los poros dilatados y aporta una luminosidad tipo miel.",
      en: "Unlock a glowing complexion. Regulates excess oil, minimizes large pores, and infuses honey-like honey glow.",
      ko: "프로폴리스와 나이아신아마이드 배합으로 여드름 흉터를 예방하고 맑고 꿀광 도는 투명한 피부를 완성."
    },
    imageUrl: "https://images.unsplash.com/photo-1608248597481-496100c80836?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "cosrx_snail_essence",
    brand: "COSRX",
    name: "Advanced Snail 96 Mucin Power Essence",
    step: 3,
    isDia: true,
    isNoche: true,
    price: "21.90",
    link: "https://21hermosa.es/products/cosrx-advanced-snail-96-mucin-power-essence",
    skinTypeScore: { dry: 3, oily: 1, combination: 2, sensitive: 2 },
    concernScore: { dryness: 3, acne: 2, redness: 2, dullness: 2 },
    ageScore: { teen: 1, twenties: 2, thirties: 3, forties: 3 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["snail", "hyaluronic"], // 달팽이점액, 히알루론산
    keyIngredients: {
      es: "96.3% Filtrado de Secreción de Caracol (Snail Mucin), Hialuronato de Sodio",
      en: "96.3% Snail Secretion Filtrate (Snail Mucin), Sodium Hyaluronate",
      ko: "달팽이점액여과물 96.3%, 소듐하이알루로네이트"
    },
    description: {
      es: "Esencia nutritiva de textura ligera y viscosa que repara las imperfecciones, suaviza las arrugas y mejora la elasticidad de las pieles maduras.",
      en: "A deeply nourishing essence that repairs skin texture, plumps fine lines, and restores elasticity with 96% pure snail mucin.",
      ko: "피부 재생 및 흉터 복원에 탁월하며 잔주름과 탄력을 끌어올리는 고농축 달팽이 점액 에센스."
    },
    imageUrl: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "anua_niacinamide_serum",
    brand: "Anua",
    name: "Niacinamide 10% + TXA 4% Dark Spot Correcting Serum",
    step: 3,
    isDia: true,
    isNoche: true,
    price: "26.00",
    link: "https://21hermosa.es/products/anua-niacinamide-10-txa-4-serum",
    skinTypeScore: { dry: 2, oily: 2, combination: 3, sensitive: 2 },
    concernScore: { dryness: 1, acne: 1, redness: 2, dullness: 3 },
    ageScore: { teen: 1, twenties: 3, thirties: 3, forties: 3 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["niacinamide", "tranexamic", "arbutin"], // 나이아신아마이드
    keyIngredients: {
      es: "10% Niacinamida, 4% Ácido Tranexámico (TXA), 2% Arbutina",
      en: "10% Niacinamide, 4% Tranexamic Acid (TXA), 2% Arbutin",
      ko: "나이아신아마이드 10%, 트라네사믹애씨드 4%, 알부틴 2%"
    },
    description: {
      es: "Sérum intensivo antimanchas formulado con potentes activos para atenuar la hiperpigmentación, pecas y unificar el tono apagado.",
      en: "An intensive brightening serum formulated to visibly fade dark spots, hyperpigmentation, and stubborn acne scars.",
      ko: "기미, 잡티, 색소침착을 집중 타겟하여 칙칙한 피부톤을 맑고 투명하게 되돌려주는 고기능성 미백 세럼."
    },
    imageUrl: "https://images.unsplash.com/photo-1617897903246-719242758050?auto=format&fit=crop&q=80&w=200"
  },

  // ==================== 4단계: 크림 (Crema Hidratante) ====================
  {
    id: "iunik_centella_gel_cream",
    brand: "iUNIK",
    name: "Centella Calming Gel Cream",
    step: 4,
    isDia: true,
    isNoche: true,
    price: "16.90",
    link: "https://21hermosa.es/products/iunik-centella-calming-gel-cream",
    skinTypeScore: { dry: 1, oily: 3, combination: 3, sensitive: 2 },
    concernScore: { dryness: 1, acne: 3, redness: 2, dullness: 1 },
    ageScore: { teen: 3, twenties: 3, thirties: 2, forties: 1 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["centella", "teatree"], // 병풀(센텔라), 티트리
    keyIngredients: {
      es: "72% Agua de Hoja de Centella Asiática, 10% Agua de Hoja de Árbol de Té",
      en: "72% Centella Asiatica Leaf Water, 10% Tea Tree Leaf Water",
      ko: "병풀잎수 72%, 티트리잎수 10%"
    },
    description: {
      es: "Crema en gel refrescante y libre de aceites que calma instantáneamente las pieles grasas, con acné o con tendencia a enrojecerse sin engrasar.",
      en: "A refreshing, oil-free gel cream that instantly soothes oily, acne-prone, and hot skin without adding extra grease.",
      ko: "끈적임 없이 산뜻하게 수분만 충전해 주는 지성 및 트러블 맞춤형 무오일 병풀 진정 젤 크림."
    },
    imageUrl: "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "etude_soonjung_barrier_cream",
    brand: "ETUDE",
    name: "SoonJung 2x Barrier Intensive Cream",
    step: 4,
    isDia: true,
    isNoche: true,
    price: "19.90",
    link: "https://21hermosa.es/products/etude-house-soonjung-2x-barrier-intensive-cream",
    skinTypeScore: { dry: 3, oily: 1, combination: 2, sensitive: 3 },
    concernScore: { dryness: 3, acne: 1, redness: 3, dullness: 1 },
    ageScore: { teen: 2, twenties: 3, thirties: 3, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["panthenol", "madecassoside"], // 판테놀, 마데카소사이드(병풀유래)
    keyIngredients: {
      es: "Pantenol (Hidratación profunda), Madecassoside (Reparación de la barrera)",
      en: "Panthenol (Deep hydration), Madecassoside (Barrier recovery)",
      ko: "판테놀 (강력 보습), 마데카소사이드 (피부 장벽 강화)"
    },
    description: {
      es: "Crema súper reconfortante e hipoalergénica de bajo pH que ayuda a fortalecer la barrera protectora de las pieles más secas o sensibles.",
      en: "A hyper-soothing, low-pH cream that deeply moisturizes and repairs dry, peeling, and sensitized skin barriers.",
      ko: "자극 지수 0%의 순한 약산성 보습 크림으로 건조하고 잔뜩 예민해진 피부 장벽을 촘촘히 치유."
    },
    imageUrl: "https://images.unsplash.com/photo-1617897903246-719242758050?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "roundlab_birch_cream",
    brand: "Round Lab",
    name: "Birch Juice Moisturizing Cream",
    step: 4,
    isDia: true,
    isNoche: true,
    price: "22.00",
    link: "https://21hermosa.es/products/round-lab-birch-juice-moisturizing-cream",
    skinTypeScore: { dry: 3, oily: 2, combination: 3, sensitive: 2 },
    concernScore: { dryness: 3, acne: 1, redness: 2, dullness: 1 },
    ageScore: { teen: 2, twenties: 3, thirties: 3, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["birchsap", "hyaluronic"], // 자작나무수액, 히알루론산
    keyIngredients: {
      es: "Savia de Abedul Plateado, Ácido Hialurónico",
      en: "Birch Tree Sap, Hyaluronic Acid",
      ko: "자작나무 수액, 히알루론산"
    },
    description: {
      es: "Crema gelificada acuosa que forma una barrera de humedad refrescante sobre la piel, ideal para pieles deshidratadas y de textura irregular.",
      en: "A water-gel cream that builds a refreshing moisture barrier on the skin, perfect for dull, dehydrated, and flakey skin.",
      ko: "풍부한 자작나무 수액 캡슐이 끈적임 없이 투명한 수분막을 씌워 오랫동안 촉촉하게 감싸주는 수분 크림."
    },
    imageUrl: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "cosrx_snail_cream",
    brand: "COSRX",
    name: "Advanced Snail 92 All In One Cream",
    step: 4,
    isDia: true,
    isNoche: true,
    price: "24.00",
    link: "https://21hermosa.es/products/cosrx-advanced-snail-92-all-in-one-cream",
    skinTypeScore: { dry: 3, oily: 1, combination: 3, sensitive: 2 },
    concernScore: { dryness: 3, acne: 2, redness: 2, dullness: 2 },
    ageScore: { teen: 1, twenties: 2, thirties: 3, forties: 3 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "none",
    ingredientsTags: ["snail", "allantoin"], // 달팽이점액, 알란토인
    keyIngredients: {
      es: "92% Filtrado de Secreción de Caracol (Snail Mucin), Alantoína",
      en: "92% Snail Secretion Filtrate (Snail Mucin), Allantoin",
      ko: "달팽이점액여과물 92%, 알란토인"
    },
    description: {
      es: "Crema todo en uno enriquecida con mucina de caracol que repara, nutre y regenera intensamente la piel aportando elasticidad y desvaneciendo arrugas.",
      en: "An all-in-one moisturizing cream that intensely repairs, nourishes, and plumps fine lines with 92% pure snail filtrate.",
      ko: "달팽이 점액 92%가 풍부한 영양을 주어 피부 푸석함을 제거하고 쫀쫀한 탄력을 채우는 안티에이징 올인원 크림."
    },
    imageUrl: "https://images.unsplash.com/photo-1608248597481-496100c80836?auto=format&fit=crop&q=80&w=200"
  },

  // ==================== 5단계: 자외선 차단제 (Protector Solar - 아침 전용) ====================
  {
    id: "joseon_relief_sun",
    brand: "Beauty of Joseon",
    name: "Relief Sun : Rice + Probiotics SPF50+",
    step: 5,
    isDia: true,
    isNoche: false,
    price: "18.90",
    link: "https://21hermosa.es/products/beauty-of-joseon-relief-sun-rice-probiotics-spf50",
    skinTypeScore: { dry: 3, oily: 1, combination: 3, sensitive: 2 },
    concernScore: { dryness: 3, acne: 1, redness: 2, dullness: 2 },
    ageScore: { teen: 2, twenties: 3, thirties: 3, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "chemical",
    ingredientsTags: ["rice", "probiotics", "chemicalfilter"], // 쌀추출물
    keyIngredients: {
      es: "30% Extracto de Arroz, Probióticos fermentados",
      en: "30% Rice Extract, Grain Fermented Probiotics",
      ko: "쌀추출물 30%, 곡물 발효 프로바이오틱스"
    },
    description: {
      es: "Protector solar químico ligero y cremoso que se absorbe como una loción hidratante sin dejar rastro blanco ni sensación pegajosa.",
      en: "A creamy organic sunscreen that glides on like a light moisturizer without any white cast or greasy finish.",
      ko: "부드럽고 촉촉한 로션처럼 마무리되어 백탁과 번들거림이 전혀 없는 베스트셀러 유기자차 선크림."
    },
    imageUrl: "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "skin1004_hyalucica_sun",
    brand: "Skin1004",
    name: "Madagascar Centella Hyalu-Cica Water-Fit Sun Serum SPF50+",
    step: 5,
    isDia: true,
    isNoche: false,
    price: "19.90",
    link: "https://21hermosa.es/products/skin1004-madagascar-centella-hyalu-cica-water-fit-sun-serum",
    skinTypeScore: { dry: 2, oily: 2, combination: 3, sensitive: 3 },
    concernScore: { dryness: 2, acne: 2, redness: 3, dullness: 1 },
    ageScore: { teen: 3, twenties: 3, thirties: 3, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "chemical",
    ingredientsTags: ["centella", "hyaluronic", "chemicalfilter"], // 병풀(센텔라), 히알루론산
    keyIngredients: {
      es: "Centella Asiática, Ácido Hialurónico, Filtros Químicos estables",
      en: "Centella Asiatica, Hyaluronic Acid, Stable Chemical Filters",
      ko: "병풀 추출물, 히알루론산, 고성능 유기 필터"
    },
    description: {
      es: "Protector solar de textura sérum acuoso súper ligera que calma la piel inflamada o sensible mientras aporta una hidratación refrescante.",
      en: "A serum-like, ultra-light organic sunscreen that deeply hydrates and soothes irritated skin without stinging eyes.",
      ko: "눈시림 없이 수분 앰플처럼 투명하고 얇게 밀착되어 사계절 산뜻하게 바르는 에센스형 유기자차."
    },
    imageUrl: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?auto=format&fit=crop&q=80&w=200"
  },
  {
    id: "etude_soonjung_mineral_sun",
    brand: "ETUDE",
    name: "SoonJung Director's Mineral Filter Sunscreen SPF50+",
    step: 5,
    isDia: true,
    isNoche: false,
    price: "19.90",
    link: "https://21hermosa.es/products/etude-house-soonjung-directors-mineral-filter-sunscreen",
    skinTypeScore: { dry: 2, oily: 2, combination: 2, sensitive: 3 },
    concernScore: { dryness: 1, acne: 3, redness: 3, dullness: 1 },
    ageScore: { teen: 3, twenties: 3, thirties: 2, forties: 2 },
    pregnancySafe: true,
    fragranceFree: true,
    sunscreenType: "physical",
    ingredientsTags: ["zincoxide", "panthenol", "madecassoside", "physicalfilter"], // 징크옥사이드, 판테놀, 마데카소사이드
    keyIngredients: {
      es: "Filtros Minerales (Óxido de Zinc), Pantenol, Madecassoside",
      en: "Mineral Filters (Zinc Oxide), Panthenol, Madecassoside",
      ko: "물리 차단 필터 (징크옥사이드), 판테놀, 마데카소사이드"
    },
    description: {
      es: "Protector solar 100% mineral (físico) de bajo pH diseñado especialmente para pieles extremadamente sensibles, reactivas o mujeres embarazadas.",
      en: "A 100% mineral (physical) low-pH sunscreen designed for extremely reactive skin, highly recommended during pregnancy.",
      ko: "민감성 피부와 임산부에게 완벽한 100% 무기자차로, 자극 없는 순한 보호막을 제공하는 안심 선크림."
    },
    imageUrl: "https://images.unsplash.com/photo-1608248597481-496100c80836?auto=format&fit=crop&q=80&w=200"
  }
];

// LocalStorage 및 모듈 관리 연동
let products = [...initialProducts];

if (typeof window !== "undefined") {
  const saved = localStorage.getItem("21hermosa_products");
  if (saved) {
    try {
      products = JSON.parse(saved);
    } catch (e) {
      console.error("Failed to parse custom products", e);
    }
  }
}

window.productsDatabase = {
  getProducts: () => products,
  saveProducts: (newProducts) => {
    products = newProducts;
    localStorage.setItem("21hermosa_products", JSON.stringify(products));
  },
  resetProducts: () => {
    products = [...initialProducts];
    localStorage.removeItem("21hermosa_products");
  }
};
